/* eslint-disable import/order */
import { formSubmitPageEntrypoint } from '@jira/router-routes__business-form-entries/src/ui/form-submit-public/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareFormSubmitClassicPublicRoute } from '@jira/router-routes__classic-projects-routes/src/softwareFormSubmitClassicPublicRoute.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareFormSubmitClassicPublicRouteEntry: Route = createEntry(
	softwareFormSubmitClassicPublicRoute,
	() => ({
		group: 'classic-software',
		ufoName: 'classic-form-submit-public',
		layout: chromelessLayout,
		resources: [...jiraSpaResources()],

		// This public route should not include
		// DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
		// remove all usages of projectKey.
		entryPoint: () => formSubmitPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
